import { getPrimaryAccount, getAccountData } from "../../../../utils/sessionUtil";
import { fork, call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import asyncInterface from "../../../../asyncInterface";
import { contributionActivityAPI, makeAContributionAPI } from "../../../../services/drupalServices";
import * as actionTypes from './actionTypes';

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  const data = fetchData.contributionActivity.fetchAccountData(fetchPayload);
  return data;
}

export function submitData(fetchPayload) {
  const fetchData = asyncInterface.init();
  const data = fetchData.contributionActivity.submitData(fetchPayload);
  return data;
}

export function* fetchContributionActivityDataWorker(fetchPayload) {
  try {
    const fetchObj = fetchPayload.payload.metaData;
    const fetchUrls = fetchPayload.payload.metaData.url;
    const fetchArr = [];
    for (const key in fetchUrls) {
      if (Object.prototype.hasOwnProperty.call(fetchUrls, key)) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: fetchUrls[key]
        });
        fetchArr.push(keyObj);
      }
    }
    const fetchedArr = yield all(
      fetchArr.map(each => call(fetchAccountData, each))
    );
    const confirmationSuccessMessage = yield call(
      contributionActivityAPI.getPageDetails
    );
    const alertMessage = yield call(
      contributionActivityAPI.alertBox
    );
    yield put({
      type: actionTypes.fetchCADrupalType,
      payload: { pageDetails: confirmationSuccessMessage.data[0], alert: alertMessage.data[0]}
    });
    yield put({
      type: actionTypes.fetchCADataSuccessType,
      payload: { response:  fetchedArr[0].data, fetchPayload: fetchPayload.payload }
    });
  
    const fetchUrlsWholeData ={
      contributionActivity: `/donor-portal/api/contribution/${
        getPrimaryAccount().userId
        }/findByAccountIdStartDateAndEndDate?startDateStr=10/04/1900&endDateStr=06/18/2100`
    };
    const fetchArrWholeData = [];
    for (const key in fetchUrlsWholeData) {
      if (Object.prototype.hasOwnProperty.call(fetchUrlsWholeData, key)) {
        const keyObj = Object.assign({
          method: "GET",
          url: fetchUrlsWholeData[key]
        });
        fetchArrWholeData.push(keyObj);
      }
    }
    const fetchedArrWholeData = yield all(
      fetchArrWholeData.map(each => call(fetchAccountData, each))
    );

yield put({
  type: actionTypes.fetchCWholeADataSuccessType,
  payload: { response: fetchedArrWholeData[0].data, fetchPayload: fetchPayload.payload }
});
  } catch (error) {
    yield put({
      type: actionTypes.fetchDataFailureType,
      error
    });
  }
}

export function* fetchContributionDataWorker(fetchPayload) {
  try {
    const fetchObj = fetchPayload.payload.metaData;
    const fetchUrls = fetchPayload.payload.metaData.url;
    const fetchArr = [];
    for (const key in fetchUrls) {
      if (Object.prototype.hasOwnProperty.call(fetchUrls, key)) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: fetchUrls[key]
        });
        fetchArr.push(keyObj);
      }
    }
    const fetchedArr = yield all(
      fetchArr.map(each => call(fetchAccountData, each))
    );
    const wiringInstructions = yield call(
      makeAContributionAPI.wiringInstructions
    );
   
    yield put({
      type: actionTypes.fetchDropdownDataType,
      payload: { response: fetchedArr[1].data, fetchPayload: fetchPayload.payload }
    });
    yield put({
      type: actionTypes.fetchCADataByIdSuccessType,
      payload: { response: fetchedArr[0].data, fetchPayload: fetchPayload.payload }
    });
    yield put({
      type: actionTypes.fetchCADrupalWireType,
      payload: { response: wiringInstructions.data[0] }
    });

  } catch (error) {
    yield put({
      type: actionTypes.fetchDataFailureType,
      error
    });
  }
}

export function* cancelContributionWorker(fetchPayload){
  try {
    const fetchObj = fetchPayload.payload.metaData;
    const fetchUrls = fetchPayload.payload.metaData.url;
    const fetchArr = [];
    for (const key in fetchUrls) {
      if (Object.prototype.hasOwnProperty.call(fetchUrls, key)) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: fetchUrls[key],
          data: fetchObj.data
        });
        fetchArr.push(keyObj);
      }
    }
    const fetchedArr = yield all(
      fetchArr.map(each => call(submitData, each))
    );
    yield put({
      type: actionTypes.cancelOneContributionType,
      payload:{type:"DataAfterCancel" }
    });
    let data = {
      "type": actionTypes.fetchCADataType,
      "payload": {
        "metaData": {
          "method":"GET",
          "page":"contributionActivity",
          "url": {"URL" :`/donor-portal/api/contribution/${getPrimaryAccount().userId}/findByAccountIdStartDateAndEndDate?startDateStr=10/04/1900&endDateStr=06/18/2100`}
        }
      }
    }
    const fetchOb = data.payload.metaData;
    const fetchUrl = data.payload.metaData.url;
    const fetchAr = [];
    for (const key in fetchUrl) {
      if (Object.prototype.hasOwnProperty.call(fetchUrl, key)) {
        const keyOb = Object.assign({
          method: fetchOb.method,
          url: fetchUrl[key]
        });
        fetchAr.push(keyOb);
      }
    }
    const fetchedAr = yield all(
      fetchAr.map(each => call(fetchAccountData, each))
    );
    yield put({
      type: actionTypes.fetchCWholeADataSuccessType,
      payload: { response: fetchedAr[0].data, fetchPayload: data.payload, type:"DataAfterCancel" }
    });
   
  } catch (error) {
    yield put({
      type: actionTypes.fetchDataFailureType,
      error
    });
  }
}

export function* cancelContributionWatcher() {
  yield takeLatest(actionTypes.cancelContributionType, cancelContributionWorker);
}


export function* fetchContrActivityWatcher() {
  yield takeEvery(actionTypes.fetchCADataType, fetchContributionActivityDataWorker);
}

export function* getContributionDataWatcher() {
  yield takeLatest(actionTypes.fetchDataByIdType, fetchContributionDataWorker)
}

export default function* contributionActivityWatcher() {
  yield all([fork(fetchContrActivityWatcher),
   fork(getContributionDataWatcher),
  fork(cancelContributionWatcher) ]);
}
